export function getProxiedImageSrc(rawUrl?: string | null): string | null {
  if (!rawUrl) {
    return null;
  }

  const trimmed = rawUrl.trim();
  if (!trimmed) {
    return null;
  }

  if (trimmed.startsWith("/")) {
    return trimmed;
  }

  try {
    const parsed = new URL(trimmed);
    const host = parsed.hostname.toLowerCase();
    const shouldProxy = host.endsWith(".cdninstagram.com") || host.endsWith(".fbcdn.net");
    if (!shouldProxy) {
      return trimmed;
    }
    return `/api/image-proxy?url=${encodeURIComponent(trimmed)}`;
  } catch {
    return null;
  }
}
